import React from "react";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppText } from "src/commun/composants/AppText";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/routes/AppRoutes";


const RattachementFormSuccess = () => {
  const { tString } = useAppText();
  const navigate = useNavigate();

  return (
    <>
      <AppCol md={8}>
        <label>{tString("migration.step.1.attach.ok")}</label>
      </AppCol>
      <AppCol md={4}>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={() => navigate(AppRoutes.ACCUEIL_PATH.getPath())}
          value={tString("action.redirect.page.accueil")}
        />
      </AppCol>
    </>
  );
};

export default RattachementFormSuccess;